import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { SharedModule } from '../shared/shared.module';
import { ShopDetailPage } from './shop-detail.page';
import { ShopDetailSharedModule } from './shared/shop-detail-shared.module';
import { PickServicesComponent } from './pick-services/pick-services.component';
import { EmployeeModalComponent } from './employee-modal/employee-modal.component';
import { ExposedComponent } from './tabs/exposed/exposed.component';
import { MenuComponent } from './tabs/menu/menu.component';
import { RatingsComponent } from './tabs/ratings/ratings.component';
import { PickMenuCleanComponent } from './pick-menu-clean/pick-menu-clean.component';
import { LoggedInGuard } from '../core/guards/logged-in.guard';
import { AgmCoreModule } from '@agm/core';
import { AngularPhoneUtilsLibModule } from 'angular-phone-utils-lib';
import { MyFilterPipe } from '../core/pipes/my-filter.pipe';

const routes: Routes = [
  {
    path: '',
    component: ShopDetailPage,
  },
  {
    path: 'jedilni-list',
    component: ShopDetailPage,
  },
  {
    path: 'ocene',
    component: ShopDetailPage,
  },
  { path: 'rezervacija/izberi-termin', loadChildren: () => import('./pick-slot/pick-slot.module').then(m => m.PickSlotPageModule) },
  { path: 'rezervacija/predogled', canActivate: [ LoggedInGuard ], loadChildren: () => import('./preview/preview.module').then(m => m.PreviewPageModule) },
  { path: 'rezervacija/placilo', canActivate: [ LoggedInGuard ], loadChildren: () => import('./payment/payment.module').then(m => m.PaymentPageModule) },
  { path: 'rezervacija/narejena/:bookingId', canActivate: [ LoggedInGuard ], loadChildren: () => import('./done/done.module').then(m => m.DonePageModule) },
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ShopDetailSharedModule,
    AgmCoreModule,
    AngularPhoneUtilsLibModule,
  ],
  declarations: [
    ShopDetailPage, 
    PickServicesComponent,
    EmployeeModalComponent,
    MyFilterPipe,
    ExposedComponent,
    MenuComponent,
    RatingsComponent,
    PickMenuCleanComponent
  ]
})
export class ShopDetailPageModule {}